import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * @param {{ params?: object, query?: object }} [option]
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.SaleStatus.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   name: { tr?: string, en?: string },
 *   description?: { tr?: string, en?: string },
 *   style?: { textColor?: string, bgColor?: string }
 * }} form
 * @param {{ params: { id: number }, query?: object }} option
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.SaleStatus.Update(option), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ id: number, newOrder: number }[]} form
 */
export const UpdateOrders = async (form) => {
  const response = await $api.post(Endpoints.SaleStatus.UpdateOrders(), form);
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetAll,
  Update,
  UpdateOrders,
};
